import { useParams } from 'react-router-dom';

import { useFirm } from './useFirm';

export function useCurrentFirm(providedFirmId?: string) {
  // Get firm_id directly from URL params
  const { firm_id } = useParams();

  // Use the provided ID or the URL param
  const firmId = providedFirmId || firm_id || '';

  // Use the existing useFirm hook to get firm data
  const { firm, isLoading, error, refetch, updateFirm } = useFirm(firmId);

  return {
    firm,
    isLoading,
    error,
    refetch,
    updateFirm,
  };
}
